/* eslint-disable @typescript-eslint/indent */
/* eslint-disable react/jsx-indent */
import HotelDetails from '@customTypes/hotel-details';
import Image from 'next/image';
import React, { useState } from 'react';
import cancelIcon from '@assets/images/unavailable.svg';
import ButtonSecondary from '@components/common/ButtonSecondary';
import BottomDrawerVariant from '@components/common/BottomDrawer/BottomDrawerVariant';
import Spinner from '@components/common/Spinner/Spinner';
import { ReactMarkdown } from 'react-markdown/lib/react-markdown';
import styles from './GetReadyTab.module.css';

type Props = {
  hotel: HotelDetails;
};

export default function GetReadyTab({ hotel }: Props) {
  const [isImproveListingDrawerOpen, setIsImproveListingDrawerOpen] = useState<boolean>(false);

  return (
    <div className="flex flex-col gap-4">
      {/* Cancellation Policy */}
      <div
        data-testid="cancellation-policy-section"
        className="border-b-8 border-rp-gray-divider pb-12 px-4"
      >
        <p className="font-rp-gelica-light text-22 leading-26px">Cancellation Policy</p>

        <p className="mt-6 leading-6">
          Cancel for full ResortPass.com credit in your account or original payment method. Credits
          never expire. Read our full{' '}
          <a
            target="_blank"
            href={hotel.changes_and_cancellation_policy.cancellation_policy_is}
            className={`${styles['link--black']} underline font-rp-pn-semi-bold text-primary-black`}
            rel="noreferrer"
          >
            cancellation policy
          </a>
        </p>

        <div className="flex flex-col mt-4 space-y-4">
          {hotel.cancel_for_rp_credit.map(
            (item: string, key: number) =>
              item && (
                // eslint-disable-next-line react/no-array-index-key
                <div key={key} className="flex">
                  <div className="relative h-6 flex-shrink-0 w-6">
                    <Image src={cancelIcon} layout="fill" alt="Cancel icon" />
                  </div>

                  <div className="ml-4">{item}</div>
                </div>
              ),
          )}
        </div>
      </div>

      {/* Know before you go */}
      {hotel.metadata.markdown_check_in_details ? (
        <div className="border-b-8 border-rp-gray-divider mt-10 pb-12 px-4">
          <p className="font-rp-gelica-light text-22 leading-26px">Know before you go</p>

          <div className="mt-6">
            <ReactMarkdown>{hotel.metadata.markdown_check_in_details}</ReactMarkdown>
          </div>
        </div>
      ) : null}

      {/* Hotel Rules */}
      {hotel.metadata.markdown_policies_details ? (
        <div className="mt-10 px-4">
          <p className="font-rp-gelica-light text-22 leading-26px">Hotel Rules</p>

          <div className="flex flex-col mt-6 space-y-4">
            {hotel.metadata.markdown_policies_details.split(/\r?\n/).map((line, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <p key={index}>{line}</p>
            ))}
          </div>
        </div>
      ) : null}

      {/* Improve this listing */}
      <div className="mt-12 px-4">
        <div className="font-rp-pn-semi-bold text-center text-rp-disabled text-sm">
          <p>Something missing?</p>
          <p>Suggest edits to improve what we show</p>
        </div>

        <ButtonSecondary onClick={() => setIsImproveListingDrawerOpen(true)} classes="mt-2">
          Improve This Listing
        </ButtonSecondary>
      </div>

      {/* Improve This Listing Drawer */}
      {isImproveListingDrawerOpen && (
        <BottomDrawerVariant
          isOpen={isImproveListingDrawerOpen}
          setIsOpen={setIsImproveListingDrawerOpen}
          title="Improve This Listing"
        >
          <div
            className="absolute"
            style={{
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
            }}
          >
            <Spinner classes="" />
          </div>

          <iframe
            title="Improve This Listing"
            className="airtable-embed bg-transparent border-none z-10"
            src="https://airtable.com/embed/shrBdRu9buWBybMIg?backgroundColor=teal"
            width="100%"
            height="533"
          />
        </BottomDrawerVariant>
      )}
    </div>
  );
}
